// Export the Component Definition for use in Contentful Studio
export {LogoCollectionContentfulComponentDefinition} from './LogoCollectionContentfulDefinition';
export {default} from './LogoCollection';
